const BaseColors = {
  // V5 Brand Colors
  zapier: 'var(--zds-colors-zapier, #ff4f00)',
  earth: 'var(--zds-colors-earth, #31201F)',
  moss: 'var(--zds-colors-moss, #1a4a4c)',
  night: 'var(--zds-colors-night, #2c3266)',
  lavender: 'var(--zds-colors-lavender, #c1b7ff)',
  peach: 'var(--zds-colors-peach, #ffe7d1)',
  bolt: 'var(--zds-colors-bolt, #fdff9f)',
  sky: 'var(--zds-colors-sky, #9ddef3)',
  cream: 'var(--zds-colors-cream, #fff3e6)',

  // Lava (oranges / brand)
  lava: 'var(--zds-colors-lava, #ff4a00)',
  lava120: 'var(--zds-colors-lava-120, #d93f00)',
  lava80: 'var(--zds-colors-lava-80, #ff6e33)',
  lava60: 'var(--zds-colors-lava-60, #ff9266)',
  lava40: 'var(--zds-colors-lava-40, #ffb799)',
  lava20: 'var(--zds-colors-lava-20, #ffdbcc)',
  lava10: 'var(--zds-colors-lava-10, #ffede6)',
  lava5: 'var(--zds-colors-lava-5, #fff6f2)',

  // Ocean (blues)
  ocean: 'var(--zds-colors-ocean, #136bf5)',
  ocean120: 'var(--zds-colors-ocean-120, #2655bd)',
  ocean80: 'var(--zds-colors-ocean-80, #4289f7)',
  ocean60: 'var(--zds-colors-ocean-60, #71a6f9)',
  ocean40: 'var(--zds-colors-ocean-40, #a1c4fb)',
  ocean20: 'var(--zds-colors-ocean-20, #d0e1fd)',
  ocean10: 'var(--zds-colors-ocean-10, #e7f0fe)',
  ocean5: 'var(--zds-colors-ocean-5, #f3f8ff)',

  // Blue Jeans (blues)
  blue: 'var(--zds-colors-blue-jeans, #3d4592)',
  blue80: 'var(--zds-colors-bluebell, #5e71c7)',
  blue60: 'var(--zds-colors-periwinkle, #90a1ed)',
  blue40: 'var(--zds-colors-lilac, #b2bce9)',
  blue20: 'var(--zds-colors-hydrangea, #d2d8f3)',
  blue10: 'var(--zds-colors-acid-wash, #f0f1fa)',

  // Sun (yellows)
  sun: 'var(--zds-colors-sun, #ffc43e)',
  sun120: 'var(--zds-colors-sun-120, #e6b038)',
  sun80: 'var(--zds-colors-sun-80, #ffd065)',
  sun60: 'var(--zds-colors-sun-60, #ffdc8b)',
  sun40: 'var(--zds-colors-sun-40, #ffe7b2)',
  sun20: 'var(--zds-colors-sun-20, #fff3d8)',
  sun10: 'var(--zds-colors-sun-10, #fff9ec)',
  sun5: 'var(--zds-colors-sun-5, #fffcf5)',

  // Error
  error: 'var(--zds-colors-error, #e02d00)',
  error10: 'var(--zds-colors-error-10, #ffe1d5)',
  error120: 'var(--zds-colors-error-120, #b92602)',
  error500: 'var(--zds-colors-error-500, #b83519)',
  error400: 'var(--zds-colors-error-400, #ce482d)',
  error300: 'var(--zds-colors-error-300, #e87057)',
  error200: 'var(--zds-colors-error-200, #feb7a8)',
  error100: 'var(--zds-colors-error-100, #fadfd9)',

  // Warning
  warning: 'var(--zds-colors-warning, #ffc43e)',
  warning10: 'var(--zds-colors-warning-10, #ffe7b2)',
  warning500: 'var(--zds-colors-warning-500, #dfb900)',
  warning400: 'var(--zds-colors-warning-400, #ffd300)',
  warning300: 'var(--zds-colors-warning-300, #f8df68)',
  warning200: 'var(--zds-colors-warning-200, #fcec9f)',
  warning100: 'var(--zds-colors-warning-100, #fff4bc)',

  // Success
  success: 'var(--zds-colors-success, #62d493)',
  success10: 'var(--zds-colors-success-10, #daf5e6)',
  success500: 'var(--zds-colors-success-500, #086f3d)',
  success400: 'var(--zds-colors-success-400, #0f884e)',
  success300: 'var(--zds-colors-success-300, #36a770)',
  success200: 'var(--zds-colors-success-200, #ade2c8)',
  success100: 'var(--zds-colors-success-100, #def3e9)',

  // Grays
  gray: 'var(--zds-colors-gray, #333333)',
  gray80: 'var(--zds-colors-gray-80, #424242)',
  gray60: 'var(--zds-colors-gray-60, #757575)',
  gray40: 'var(--zds-colors-gray-40, #cccccc)',
  gray20: 'var(--zds-colors-gray-20, #e6e6e6)',
  gray10: 'var(--zds-colors-gray-10, #f2f2f2)',
  gray5: 'var(--zds-colors-gray-5, #fafafa)',

  // Neutrals
  neutral800: 'var( --zds-colors-neutral-800, #2d2e2e)',
  neutral700: 'var(--zds-colors-neutral-700, #403f3e)',
  neutral600: 'var( --zds-colors-neutral-600, #95928e)',
  neutral500: 'var( --zds-colors-neutral-500, #a8a5a0)',
  neutral400: 'var( --zds-colors-neutral-400, #d7d5d2)',
  neutral300: 'var( --zds-colors-neutral-300, #e8e7e4)',
  neutral200: 'var( --zds-colors-neutral-200, #f7f5f2)',
  neutral100: 'var( --zds-colors-neutral-100, #fffdf9)',

  // Special colors
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent',
  inherit: 'inherit',
  currentColor: 'currentColor',
} as const;

/** Alias common color assignments for consistency in implementations */
const ColorAliases = {
  brand: BaseColors.lava,
  blueJeans: BaseColors.blue,
  bluebell: BaseColors.blue80,
  periwinkle: BaseColors.blue60,
  lilac: BaseColors.blue40,
  hydrangea: BaseColors.blue20,
  acidWash: BaseColors.blue10,
};

export const Colors = { ...BaseColors, ...ColorAliases };

export type ColorName = keyof typeof Colors;
export type ColorValue = typeof Colors[ColorName];
